<template>
  <sui-dropdown
    :text="titleForSelectedItem"
  >
    <sui-dropdown-menu>
      <sui-dropdown-item
        v-for="item in items"
        :key="keyForItem(item)"
        @click.native="itemSelected(item)"
      >
        {{ titleForItem(item) }}
      </sui-dropdown-item>
    </sui-dropdown-menu>
  </sui-dropdown>
</template>

<script>
export default {
  name: 'Picker',
  props: {
    items: {
      type: Array,
    },
    keyProperty: {
      type: String,
    },
    displayProperty: {
      type: String,
    },
    placeholder: {
      type: String,
      default: 'Select an Item',
    },
  },
  data () {
    return {
      selected: '',
    }
  },
  computed: {
    titleForSelectedItem: function () {
      return this.titleForItem(this.selected)
    },
  },
  methods: {
    titleForItem: function (item) {
      if (!item) {
        return this.placeholder
      }
      if (this.displayProperty) {
        return item[this.displayProperty]
      }
      throw new Error('Implement the Picker as a mixin or pass a property name.')
    },
    keyForItem: function (item) {
      if (this.keyProperty) {
        return item[this.keyProperty]
      }
      throw new Error('Implement the Picker as a mixin or pass a property name.')
    },
    itemSelected: function (item) {
      this.$emit('change', item)
      this.selected = item
    },
  },
}
</script>

<style scoped>
  .picker {
    z-index: 999;
  }
</style>
